import { render, staticRenderFns } from "./RecPointModal.vue?vue&type=template&id=5fe4980c&scoped=true"
import script from "./RecPointModal.vue?vue&type=script&lang=js"
export * from "./RecPointModal.vue?vue&type=script&lang=js"
import style0 from "./RecPointModal.vue?vue&type=style&index=0&id=5fe4980c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fe4980c",
  null
  
)

export default component.exports